import MarketplaceAgent from "../agent/marketplace-agent";
import {makeAutoObservable} from "mobx";
import {DocumentMetadataResponse} from "../../entity/resource/document-metadata-response";
import {DocumentMetadataRequestDto} from "../../entity/dto/document-metadata-request-dto";
import {FilterMetadataRequestDto} from "../../entity/dto/filter-metadata-request-dto";
import {FilterMetadataResponse} from "../../entity/resource/filter-metadata-response";
import {MarketplaceRecordRequestDto} from "../../entity/dto/marketplace-record-request-dto";
import {MarketplaceRecordResponse} from "../../entity/resource/marketplace-record-response";

export default class MarketplaceStore {
    marketplaceAgent: MarketplaceAgent;

    constructor(marketplaceAgent: MarketplaceAgent) {
        makeAutoObservable(this);
        this.marketplaceAgent = marketplaceAgent;
    }

    getDocumentMetadata = async (payload: DocumentMetadataRequestDto): Promise<DocumentMetadataResponse | string> => {
        try {
            return this.marketplaceAgent.getDocumentMetadata(payload);
        } catch (error: any) {
            console.error('An error occurred while getting the Metadata !!', error);
            return 'An error occurred while getting the Metadata !!';
        }
    }

    filterMetaData = async (payload: FilterMetadataRequestDto): Promise<FilterMetadataResponse[] | string> => {
        try{
            return this.marketplaceAgent.filterMetaData(payload);
        } catch (error: any) {
            console.error('An error occurred while filterMetaData !!', error);
            return 'An error occurred while filterMetaData !!';
        }
    }

    createMarketplaceRecord = async (organizationID: string, payload: MarketplaceRecordRequestDto): Promise<MarketplaceRecordResponse | string> => {
        try {
            return this.marketplaceAgent.createMarketplaceRecord(organizationID, payload);
        } catch (error: any) {
            console.error('An error occurred while creating marketplace record !!', error);
            return 'An error occurred while creating marketplace record !!';
        }
    }

    downloadMarketplaceDocument = async (organizationId: string, batchId: string): Promise<{success: boolean, message: string, downloadUrl: string, fileName: string, expiresIn: string} | string> => {
        try {
            return await this.marketplaceAgent.downloadMarketplaceDocument(organizationId, batchId);
        } catch (error: any) {
            console.error('An error occurred while downloading marketplace document !!', error);
            return 'Failed to download document. Please try again.';
        }
    }
}
